<template>
  <form :action="deleteRoute" method="POST" class="delete-modal">
    <input type="hidden" name="_method" value="DELETE" />
    <input type="hidden" name="_token" :value="$page.props.csrf_token" />
    <div class="modal-card">
      <header class="modal-card-head">
        <p>
          <b>Are you sure that you want to delete {{ name }}?</b>
        </p>
        <button type="button" class="delete ml-auto" @click="$parent.close()" />
      </header>
      <section class="modal-card-body">
        <p v-if="message">
          {{ message }}
        </p>
        <p>
          Please type in the name, <b>{{ name }}</b> to confirm you would like
          to delete it
        </p>
        <b-input v-model="confirmation" placeholder="Type name here"></b-input>
        <b-button
          native-type="submit"
          :disabled="name !== confirmation"
          type="is-danger"
          >Delete</b-button
        >
      </section>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    name: { type: String },
    message: { type: String },
    deleteRoute: { type: String },
  },
  data() {
    return {
      confirmation: '',
    };
  },
};
</script>
